<template>
  <div :class="[className, 'heading flex align-center']">
    <h3>{{ heading }}</h3>
  </div>
</template>

<script>
export default {
  props: {
    heading: {
      type: String
    },
    className: {
      type: String
    }
  }
};
</script>

<style scoped>
.heading h3 {
  margin: 0;
  padding: 0;
  font-weight: 600;
  font-size: var(--fs-h2);
  line-height: 1.3;
  letter-spacing: var(--tracking-tight);
  color: var(--ink-900);
  text-transform: none;
}
.go-back:before {
  font-size: 24px !important;
  margin-top: 3px;
  margin-right: 8px;
}
</style>
